import { useMutation } from "@apollo/client";
import {
  Button,
  Grid,
  LoadingOverlay,
  NumberInput,
  Select,
  Stack,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { CREATE_DISCOUNT } from "apollo/mutuations";
import { PRODUCT_DISCOUNT } from "apollo/queries";
import { customLoader } from "components/utilities/loader";
import { formatLocalDate } from "utiles/url";

export const DiscountAddModal = ({
  product,
  refetch,
  setOpened,
  activePage,
}) => {
  const { height } = useViewportSize();

  const form = useForm({
    initialValues: {
      product_id: product || "",
      discount_value_type: "PERCENTAGE",
      discount_value: 0,
      start_date: null,
      end_date: null,
    },
    validate: {
      discount_value_type: (value) =>
        value ? null : "Discount type is required",
      discount_value: (value) =>
        value > 0 ? null : "Discount value must be greater than 0",
      start_date: (value) => (value ? null : "Start date is required"),
      end_date: (value, values) => {
        if (
          value &&
          values.start_date &&
          new Date(value) < new Date(values.start_date)
        ) {
          return "End date must be after start date";
        }
        return null;
      },
    },
  });
  const [addDiscount, { loading: discountLoading }] =
    useMutation(CREATE_DISCOUNT);

  const submit = () => {
    addDiscount({
      variables: {
        product_id: form.getInputProps("product_id").value,
        discount_value_type: form.getInputProps("discount_value_type").value,
        discount_value: parseFloat(form.getInputProps("discount_value").value),
        start_date: formatLocalDate(form.getInputProps("start_date").value),
        end_date: form.getInputProps("end_date").value
          ? formatLocalDate(form.getInputProps("end_date").value)
          : null,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Discount Created Successfully",
        });
        refetch();
        setOpened(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Create Discount",
        });
      },
    });
  };

  return (
    <>
      <LoadingOverlay
        visible={discountLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <form onSubmit={form.onSubmit(() => submit())}>
        <Stack>
          <Grid>
            <Grid.Col span={4}>
              <Select
                required
                label="Discount Type"
                placeholder="Select discount type"
                data={[
                  { value: "PERCENTAGE", label: "Percentage" },
                  { value: "FLAT", label: "Flat" },
                ]}
                {...form.getInputProps("discount_value_type")}
              />
              <NumberInput
                required
                label="Discount Value"
                placeholder="Enter discount value"
                min={0}
                {...form.getInputProps("discount_value")}
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <DatePicker
                required
                label="Start Date"
                placeholder="Select start date"
                {...form.getInputProps("start_date")}
              />
              <DatePicker
                label="End Date"
                placeholder="Select end date"
                {...form.getInputProps("end_date")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={4}>
              <Button
                type="submit"
                style={{
                  width: "25%",
                  marginTop: "15px",
                  backgroundColor: "#FF6A00",
                  color: "#FFFFFF",
                }}
                fullWidth
              >
                Submit
              </Button>
            </Grid.Col>
          </Grid>
        </Stack>
      </form>
    </>
  );
};
